<template>
    <div class="anexos-component">

        <div class="u-mb-10 u-text-right">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="abrirModal()">Adicionar anexo</el-button>
        </div>

        <div v-if="carregando" class="u-text-center u-mt-10">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <table v-else-if="linhas.length" class="table table-striped" style="margin-top: 10px;">
            <thead>
                <tr>
                    <th>ARQUIVO</th>
                    <th class="hidden-mobile">DESCRIÇÃO</th>
                    <th class="hidden-mobile">TIPO DOCUMENTO</th>
                    <th class="hidden-mobile u-text-center" style="width: 110px;">TAMANHO</th>
                    <th class="u-text-center" style="width: 130px;">AÇÕES</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(l, i) in linhas" :key="i">
                    <td>
                        <i class="el-icon-document"></i> {{ l.nome }}
                    </td>
                    <td class="hidden-mobile u-uppercase">{{ l.descricao || '-' }}</td>
                    <td class="hidden-mobile u-uppercase">{{ l.tipo_documento || '-' }}</td>
                    <td class="hidden-mobile u-text-center">{{ formatarTamanho(l.tamanho) }}</td>
                    <td class="u-text-center">
                        <a :href="l.url" target="_blank" rel="noopener">
                            <el-button type="primary" size="mini" icon="el-icon-download" title="Baixar / Visualizar"></el-button>
                        </a>
                        <el-button style="margin-left: 10px;" type="danger" size="mini" icon="el-icon-delete" title="Excluir"
                                   @click="l.salvo ? excluir(l.ref) : removerPendente(l.index)"></el-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-else style="border: 1px solid #eee; background: #fafafa; padding: 16px; text-align: center; color: #909399;">
            Nenhum anexo cadastrado.
        </div>

        <!-- Modal de adição de anexo -->
        <el-dialog title="Adicionar anexo" :visible.sync="modalVisivel" width="480px" :close-on-click-modal="false" append-to-body>
            <el-form label-position="top" @submit.native.prevent class="u-mt-20">
                
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Tipo de Documento (opcional)">
                            <el-select v-model="tipoDocumentoId" filterable clearable placeholder="Selecione" style="width: 100%;">
                                <el-option v-for="t in tiposDocumento" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Descrição (opcional)">
                            <el-input v-model="descricao" maxlength="150"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-form-item>
                            <el-upload
                                action="#"
                                :auto-upload="false"
                                :show-file-list="false"
                                :limit="1"
                                :accept="accept"
                                :http-request="dummyUpload"
                                :on-change="onFileChange"
                            >
                                <el-button size="small" type="primary" icon="el-icon-paperclip">Selecionar arquivo</el-button>
                            </el-upload>
                            <div v-if="arquivo" style="font-size: 12px; color: #606266; margin-top: 6px;">
                                <i class="el-icon-document"></i> {{ arquivo.name }} ({{ formatarTamanho(arquivo.size) }})
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer">
                <el-button @click="fecharModal()">CANCELAR</el-button>
                <el-button type="success" :loading="salvando" :disabled="!arquivo" @click="salvarModal()">SALVAR</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const EXTENSOES_PERMITIDAS = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx']

export default {
    name: 'Anexos',
    props: {
        // 'aluno' | 'servidor'
        tipo: { type: String, required: true },
        // id do registro dono do anexo (aluno_id / servidor_id). Ausente = cadastro novo.
        id: { type: [Number, String], default: null }
    },
    data: () => ({
        anexos: [],       // anexos já salvos (modo edição), vindos do backend
        pendentes: [],    // metadados de arquivos já enviados (uploadTemp), aguardando vínculo no save
        arquivo: null,    // arquivo selecionado no modal
        descricao: '',
        tipoDocumentoId: '',
        tiposDocumento: [],
        modalVisivel: false,
        carregando: false,
        salvando: false,
        tamanhoMaxKb: 5120,
        accept: '.' + EXTENSOES_PERMITIDAS.join(',.')
    }),
    computed: {
        // Unifica a exibição: anexos salvos (edição) ou pendentes (cadastro novo).
        linhas () {
            if (this.id) {
                return this.anexos.map(a => ({
                    nome: a.nome_original, descricao: a.descricao, tamanho: a.tamanho,
                    tipo_documento: a.tipo_documento ? a.tipo_documento.nome : null,
                    url: this.urlPorPath(a.path, a.url), salvo: true, ref: a
                }))
            }
            return this.pendentes.map((p, i) => ({
                nome: p.nome_original, descricao: p.descricao, tamanho: p.tamanho,
                tipo_documento: p.tipo_documento_nome,
                url: this.urlPorPath(p.path, p.url), salvo: false, index: i
            }))
        }
    },
    watch: {
        id: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.carregarTamanhoMax()
                    this.load()
                }
            }
        }
    },
    mounted () {
        // Garante o limite de tamanho também no cadastro novo (sem id).
        if (!this.id) this.carregarTamanhoMax()
        this.carregarTiposDocumento()
    },
    methods: {
        dummyUpload () { /* no-op: desliga o auto-upload do el-upload */ },

        carregarTiposDocumento () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/tipo-documento-anexo/getAllAtivos`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.tiposDocumento = Array.isArray(r.data) ? r.data : []
            }).catch(() => { /* opcional; select fica vazio se falhar */ })
        },

        abrirModal () {
            this.arquivo = null
            this.descricao = ''
            this.tipoDocumentoId = ''
            this.modalVisivel = true
        },
        fecharModal () {
            this.modalVisivel = false
            this.arquivo = null
            this.descricao = ''
            this.tipoDocumentoId = ''
        },

        load () {
            if (!this.id) return
            this.carregando = true
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/anexo/list/${this.tipo}/${this.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.anexos = Array.isArray(r.data) ? r.data : []
                this.carregando = false
            }).catch(e => {
                this.carregando = false
                this.$store.commit('throwException', e)
            })
        },

        carregarTamanhoMax () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/upload.tamanho_max_anexo_kb`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const v = parseInt(r.data && r.data.valor)
                if (!isNaN(v) && v > 0) this.tamanhoMaxKb = v
            }).catch(() => { /* mantém o padrão; o backend valida de qualquer forma */ })
        },

        onFileChange (file) {
            const raw = file.raw
            if (!raw) return

            const ext = (raw.name.split('.').pop() || '').toLowerCase()
            if (!EXTENSOES_PERMITIDAS.includes(ext)) {
                window.eventBus.$emit('alert', { msg: 'Tipo de arquivo não permitido. Aceitos: ' + EXTENSOES_PERMITIDAS.join(', ') + '.', type: 'warning' })
                this.arquivo = null
                return
            }

            if (this.tamanhoMaxKb && raw.size > this.tamanhoMaxKb * 1024) {
                window.eventBus.$emit('alert', { msg: 'Arquivo excede o tamanho máximo de ' + this.formatarTamanho(this.tamanhoMaxKb * 1024) + '.', type: 'warning' })
                this.arquivo = null
                return
            }

            this.arquivo = raw
        },

        // Salvar no modal: sobe o arquivo (uploadTemp). Em edição vincula na hora; em cadastro novo, enfileira.
        salvarModal () {
            if (!this.arquivo) return

            this.salvando = true
            this.uploadTemp(this.arquivo).then(meta => {
                if (!meta || meta.erro) {
                    this.salvando = false
                    window.eventBus.$emit('alert', { msg: (meta && meta.erro) ? meta.erro : 'Falha ao enviar o arquivo.', type: 'warning' })
                    return
                }

                meta.descricao = this.descricao || ''
                meta.tipo_documento_anexo_id = this.tipoDocumentoId || null
                var tSel = this.tiposDocumento.find(t => t.id === this.tipoDocumentoId)
                meta.tipo_documento_nome = tSel ? tSel.nome : null

                if (this.id) {
                    // Edição: vincula imediatamente ao registro existente.
                    this.vincular(this.id, [meta]).then(r => {
                        this.salvando = false
                        if (r && r.erro) {
                            window.eventBus.$emit('alert', { msg: r.erro, type: 'warning' })
                            return
                        }
                        this.fecharModal()
                        window.eventBus.$emit('alert', { msg: 'Anexo adicionado com sucesso.', type: 'success' })
                        this.load()
                    }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
                } else {
                    // Cadastro novo: guarda os metadados até o save do formulário.
                    this.pendentes.push(meta)
                    this.salvando = false
                    this.fecharModal()
                }
            }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
        },

        removerPendente (index) {
            this.pendentes.splice(index, 1)
        },

        /**
         * Vincula os pendentes ao registro recém-criado. Chamado pelo formulário-pai
         * (via $refs) logo após salvar um cadastro novo. Retorna Promise.
         */
        async vincularPendentes (novoId) {
            if (!novoId || !this.pendentes.length) return

            const r = await this.vincular(novoId, this.pendentes)
            this.pendentes = []

            if (r && r.erro) {
                window.eventBus.$emit('alert', { msg: r.erro, type: 'warning' })
            }
            if (this.id) this.load()
        },

        // --- chamadas HTTP ---
        uploadTemp (file) {
            const fd = new FormData()
            fd.append('arquivo', file)

            const opt = JSON.parse(JSON.stringify(this.$store.getters.getHeaderFileAuth))
            opt.headers['Content-Type'] = 'multipart/form-data'

            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/anexo/uploadTemp`,
                fd,
                opt
            ).then(r => r.data)
        },
        vincular (anexavelId, itens) {
            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/anexo/vincular/${this.tipo}/${anexavelId}`,
                { anexos: itens },
                this.$store.getters.getHeaderAuth
            ).then(r => r.data)
        },

        excluir (anexo) {
            this.$msgbox.confirm(`Tem certeza que deseja excluir o anexo "${anexo.nome_original}"?`, 'Atenção', {
                confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning'
            }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/anexo/delete/${anexo.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Anexo excluído com sucesso.', type: 'success' })
                    this.load()
                }).catch(e => {
                    window.eventBus.$emit('loading', false)
                    this.$store.commit('throwException', e)
                })
            }).catch(() => {})
        },

        urlPorPath (path, fallbackUrl) {
            // Padrão consolidado ${baseUrlApi}/storage/<path>; usa a url do backend como fallback.
            if (path) return `${this.$store.state.config.baseUrlApi}/storage/${path}`
            return fallbackUrl || '#'
        },

        formatarTamanho (bytes) {
            if (!bytes && bytes !== 0) return '-'
            if (bytes < 1024) return bytes + ' B'
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB'
            return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
        }
    }
}
</script>
